import { Controller } from "react-hook-form";
import CheckboxField from "./check-box";
import { CheckBoxProps } from "./check-box.type";
import AdditionalFormFields from "../common-type";

const CheckBoxFormField = (props) => {
  const { name, defaultValue, control } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CheckboxField
          {...props}
          value={value}
          onChange={onChange}
          error={error}
        />
      )}
    />
  );
};
CheckboxField.propTypes = { ...CheckBoxProps, ...AdditionalFormFields };

export default CheckBoxFormField;
